import React from 'react'
import ReactDOM from 'react-dom/client'

import 'react-datepicker/dist/react-datepicker.css'
import './index.css'
import App from './app/App'

const root = ReactDOM.createRoot(document.getElementById('root')!)

root.render(<App />)
